import { INSERE_DADOS } from './constants';

const initialState = {
  email: undefined,
  telefone: undefined,
  matricula: undefined,
  token: undefined,
  etapa: undefined,
};

// eslint-disable-next-line default-param-last
export default function recuperacaoSenha(state = initialState, action) {
  switch (action.type) {
    case INSERE_DADOS:
      return {
        ...state,
        email: action.values.email,
        telefone: action.values.telefone,
        matricula: action.values.matricula,
        token: action.values.token,
        etapa: action.values.etapa,
      };

    default:
      return state;
  }
}
